/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';

import { formatByPipSize } from '@trader/utils';

import { initialInstrument, initialRealPrice } from '../constants';
import { getRealTimePrice, getTradingModelFE } from '../utils';
import { IInstrument, IRealPrice } from '../types';
import { TPlaceOrderSide } from '@trader/api';

export interface IGetInstrumentOutput {
  instrument: IInstrument;
  realTimePrice: IRealPrice;
  getInstrumentDetailFE: (state: any, type: TPlaceOrderSide) => void;
  updateInstrument: (state: any) => void;
  updateRealTimePrice: (ask: number, bid: number) => void;
  resetInstrument: () => void;
}

export const useGetInstrument = (): IGetInstrumentOutput => {
  const [instrument, setInstrument] = useState<IInstrument>(initialInstrument);
  const [realTimePrice, setRealTimePrice] =
    useState<IRealPrice>(initialRealPrice);

  const getInstrumentDetailFE: IGetInstrumentOutput['getInstrumentDetailFE'] = (
    store,
    type
  ) => {
    setInstrument(getTradingModelFE(store, type));
    setRealTimePrice(getRealTimePrice(store));
  };

  useEffect(() => {
    return () => {
      setInstrument(initialInstrument);
      setRealTimePrice(initialRealPrice);
    };
  }, []);

  const updateInstrument: IGetInstrumentOutput['updateInstrument'] =
    newState => {
      setInstrument(newState);
    };
  const updateRealTimePrice: IGetInstrumentOutput['updateRealTimePrice'] = (
    askValue,
    bidValue
  ) => {
    const ask = formatByPipSize(Number(askValue), instrument.general.pipSize);
    const bid = formatByPipSize(Number(bidValue), instrument.general.pipSize);

    setRealTimePrice({
      ask,
      bid,
      currentPrice: ask,
    });
  };

  const resetInstrument: IGetInstrumentOutput['resetInstrument'] = () => {
    setInstrument(prev => ({
      ...prev,
      market: {
        ...prev.market,
        amountVolume: prev.market.minAmountValue.toString(),
      },
      limit: {
        ...prev.limit,
        buyValue: initialInstrument.limit.buyValue,
        sellValue: initialInstrument.limit.sellValue,
        amount: prev.market.minAmountValue.toString(),
        value: initialInstrument.limit.value,
      },
    }));
  };

  return {
    instrument,
    realTimePrice,
    getInstrumentDetailFE,
    updateInstrument,
    updateRealTimePrice,
    resetInstrument,
  };
};
